export default __webpack_public_path__ + "static/media/Wheel Blades.41d0fbed.jpg";